// extracted by mini-css-extract-plugin
export default {"categoriesListContainer":"CategoriesList_categoriesListContainer__pVSps","category":"CategoriesList_category__IBgHm","disabled":"CategoriesList_disabled__ZiKe+"};